<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from './stores/auth.store';

const auth = useAuthStore();

onMounted(async () => {
  // 啟動時嘗試恢復登入狀態（從 cookie + /auth/me 拿 user info）
  await auth.fetchMe();
});
</script>

<template>
  <router-view />
</template>
